import { getDocs, query, where } from "firebase/firestore";
import { err, ok } from "@pack-it-up/shared";
import { toDomainCategory, toDomainItem, toDomainTodo } from "../mappers/index.js";
import { toDomainError } from "./support.js";
// One-shot read of everything under a list (a trip or a template — both are lists,
// Doc 07 §2): categories carry `parentId`, items/todos the denormalised `listId`
// (Doc 02 §8). Backs `TripRepository.fetchTripContents`, which copy (issue #8) needs
// from the trip list, where nothing is streaming the trip's rows.
export const readListContents = async (p, listId) => {
    try {
        const [catSnap, itemSnap, todoSnap] = await Promise.all([
            getDocs(query(p.categories(), where("parentId", "==", listId))),
            getDocs(query(p.items(), where("listId", "==", listId))),
            getDocs(query(p.todos(), where("listId", "==", listId))),
        ]);
        const categories = [];
        for (const d of catSnap.docs) {
            const r = toDomainCategory(d.data());
            if (r.ok)
                categories.push(r.value);
        }
        const items = [];
        for (const d of itemSnap.docs) {
            const r = toDomainItem(d.data());
            if (r.ok)
                items.push(r.value);
        }
        const todos = [];
        for (const d of todoSnap.docs) {
            const r = toDomainTodo(d.data());
            if (r.ok)
                todos.push(r.value);
        }
        return ok({ categories, items, todos });
    }
    catch (e) {
        return err(toDomainError(e));
    }
};
//# sourceMappingURL=listContents.js.map